import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AmendAcuDeviceProgressStepper from "./components/amendAcuDeviceProgressStepper"
import CoreAcuDeviceDetails from "./formPages/coreAcuDeviceDetails"
import ReviewAndSubmitAcuDevice from "./formPages/reviewAndSubmitAcuDevice"
import { AmendAcuDeviceContext } from "./providers/baseProviders/amendAcuDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { HpDeviceFormData } from "../types/providerTypes"

/** The form for amending an Air Conditioning Unit device */
const AmendAcuDeviceForm = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppCard>
            <AppCardContent>
                <AmendAcuDeviceProgressStepper />
            </AppCardContent>
        </AppCard>

        <MultiPageForm context={AmendAcuDeviceContext}>
            <CoreAcuDeviceDetails context={AmendAcuDeviceContext} />
            <LctDeviceAttachments<HpDeviceFormData>
                context={AmendAcuDeviceContext}
                dataset={Datasets.ACU}
                isAmendment
            />
            <ReviewAndSubmitAcuDevice
                context={AmendAcuDeviceContext}
                isAmendment
            />
        </MultiPageForm>
    </Stack>
)

export default AmendAcuDeviceForm
